import { render, staticRenderFns } from "./FinancialTipsArticle2.vue?vue&type=template&id=12c85639&scoped=true"
import script from "./FinancialTipsArticle2.vue?vue&type=script&lang=js"
export * from "./FinancialTipsArticle2.vue?vue&type=script&lang=js"
import style0 from "./FinancialTipsArticle2.vue?vue&type=style&index=0&id=12c85639&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c85639",
  null
  
)

export default component.exports